import {
  Button, Card, CardContent, Dialog, DialogActions, DialogContent, Divider, Grid, Typography, Chip,CardActionArea,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import Confetti from 'react-confetti';
import PWAPrompt from 'react-ios-pwa-prompt';
import Tour from 'reactour';
import moment from 'moment';
import EmailIcon from '@material-ui/icons/Email';
import axios from 'src/utils/axios';
import React, { useEffect, useState } from 'react';
// GFSM-228  import GenericAnket from 'src/components/GenericSurvey';
import WelcomeMessage from 'src/components/WelcomeMessage';
import {
  GetLocation, getTourOpen, getUser, setTourOpen
} from 'src/utils/Common';

const useStyles = makeStyles((theme) => ({
  root: {},
  posts: {
    marginTop: theme.spacing(2)
  },
  post: {
    marginBottom: theme.spacing(2)
  },
  icon: {
    align: 'center',
    textAlign: 'center'
  },
  cardsMax: {
    maxHeight: 200,
    minHeight: 200
  },
}));

function Timeline({ className, ...rest }) {
  const classes = useStyles();
  const SessionUser = getUser();
  const [tour, setTour] = React.useState(getTourOpen());
  // GFSM-228  const [anketOpen, setAnketOpen] = React.useState(true);
  const [openBirthday, setopenBirthday] = React.useState(false);
  const [messages, setMessages]=useState([]);
  const steps = [
    {
      content: <Typography variant="h6" gutterBottom>
        Please Re-login after you allow Sirius to access your location
               </Typography>,
    },
    {
      selector: '[data-tour="OpenNavbarButton"]',
      content: <Typography variant="h6" gutterBottom>
        You can open the menu here
               </Typography>,
      position: 'left',
    },
    {
      selector: '[data-tour="LogoutButton"]',
      content: <Typography variant="h6" gutterBottom>
        You Can Log Out Here
               </Typography>,
      position: 'left',
    },
    {
      selector: '[data-tour="ArtemisButton"]',
      content: <Typography variant="h6" gutterBottom>
        You Can Reach Your Work Orders Here
               </Typography>,
      position: 'left',
    },
  ];

  const handleCloseBirthday = () => {
    setopenBirthday(false);
  };


  React.useEffect(() => {
    GetLocation();
    if (parseInt(SessionUser.HappyBirthday) === 1) {
      setTimeout(() => {
        setopenBirthday(false);
      }, 2000);
    }
    // eslint-disable-next-line
  }, []);

  const GetEAnnouncementInfo = () => {
    axios
      .get(`/GetAnnouncementInfo/${SessionUser.Role}`)
      .then(response => {
        if (response.data.length > 0) {
          setMessages(response.data);
        }
      })
      .catch(error => { });
  };
    
useEffect(() => {
  GetEAnnouncementInfo();
},[]);


  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Tour
        steps={steps}
        isOpen={tour}
        onRequestClose={() => { setTourOpen(); setTour(false); }}
        accentColor="#1D3343"
        className="helper"
        rounded={20}
      />
      <PWAPrompt
        promptOnVisit={1}
        timesToShow={3}
        copyTitle="Add to Home Screen"
        copyBody="The Sirius application, which you can access via the browser of your mobile device, can be easily downloaded and does not take up space on your device."
        copyShareButtonLabel={
          "1) Tap the 'Share' icon at the bottom"
        }
        copyAddHomeButtonLabel={
          "2) Click 'Add to Home Screen' in the menu that opens."
        }
        copyClosePrompt="Kapat"
        permanentlyHideOnDismiss={false}
      />
      {/* GFSM-228
      <GenericAnket anketOpen={anketOpen} setAnketOpen={setAnketOpen} anketTitle="Güne Başlama Anketi" anketId={89} birimKodu={SessionUser.TechnicianId} />
      */}
       <Card {...rest} className={clsx(classes.root, className)}>
      <CardContent className={classes.content}>
        <Grid container spacing={1}>
        {!messages ? (
              <div />
            ) : (
              messages.map((item, index) => (
                <Grid item xs={12} sm={6} lg={6} key={index}
                >
                  <Card className={classes.cardsMax}>
                    <CardActionArea>
                      <CardContent className={classes.cardsContentMax}>
                        <Typography gutterBottom variant="h6" component="h1">
                          
                          <Chip
                            style={{
                              color:'red'
                            }}
                            icon={<EmailIcon />}
                            label={item.Header}
                            
                          />
                          <br />
                            {  moment(item.StartDate).format('DD.MM.YYYY')}
                        </Typography>
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          component="p"
                        >
                        
                          <br />
                          <strong>{ 'Message : '} 
                         </strong> 
                         {(item.Dsc) }
                          <br />
                          <strong> {'Create User: ' } </strong> { (item.CreateEmployee)}
                        
                         
                          <br />
                        </Typography>
                      </CardContent>
                      </CardActionArea>
                  </Card>
                </Grid>
              ))
            )}
             </Grid>
        </CardContent>
        <Divider />
        <CardContent className={classes.icon}>
          {/* <Grid container justify="space-between">
            <Grid item xs={12} className={classes.icon}>
              <a href="https://globalcustomercare.arcelikacademy.com/login" target="_blank" rel="noopener noreferrer">
                <img width="100%" height="100%" src={servisAkademi} border="0" alt="Servis Akademi" />
              </a>
            </Grid>
          </Grid> */}
        </CardContent>
        <Divider />
      </Card>
      {/* {parseInt(SessionUser.HappyBirthday) === 1 && <Confetti />} */}
      <Dialog
        open={openBirthday}
        onClose={handleCloseBirthday}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <Confetti />
          <Typography variant="h6" component="h4">
            <br />
            Dear
            {' '}
            {SessionUser.NameSurname}
            ,
            <br />
            <br />
            Happy birthday with your loved ones, full of health, happiness and success
            I wish you many years.
            <br />
            <br />
            İyi ki doğdun!
            <br />
            <br />
            Best regards,
            <br />
            Global Customer Services Directorate
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseBirthday} color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

Timeline.propTypes = {
  className: PropTypes.string
};

export default Timeline;
